import { useGetBrand } from 'src/api/userInfo';
import { SetupDeviceFields, SetupDeviceInfo, SetupDeviceLocation } from './influx/setupDeviceInfo';


const SetupInfluxDevice = ({step,setStep, type, setDeviceDetails,deviceDetails, handleOnClose, isEditDevice, plantId, plantLocation,deviceId}) => {
   
    const { brandList, isLoadingBrandList, isErrorBrandList } = useGetBrand(type)

    return ( 
        <>
            <SetupDeviceInfo type={type} isLoading={isLoadingBrandList} brandList={brandList} step={step} setStep={setStep} setDeviceDetails={setDeviceDetails} deviceDetails={deviceDetails}/>
            <SetupDeviceFields type={type} step={step} setStep={setStep} setDeviceDetails={setDeviceDetails} deviceDetails={deviceDetails} />
            <SetupDeviceLocation step={step} setStep={setStep} 
                setDeviceDetails={setDeviceDetails} 
                deviceDetails={deviceDetails}
                plantId={plantId} 
                plantLocation={plantLocation}
                setupType={type}
                handleOnClose={handleOnClose}
                isEditDevice={isEditDevice}
                deviceId={deviceId}
                
            />    
                
        </>
       
     );
}
 
export default SetupInfluxDevice;
